import { useQuery } from "@tanstack/react-query";
import { useDataProvider } from "ra-core";

import type { CrmDataProvider } from "../providers/types";
import type { FunnelMetrics, FunnelMetricsFilters } from "../types";

export interface UseFunnelMetricsResult {
  data: FunnelMetrics | undefined;
  isPending: boolean;
  error: unknown;
  refetch: () => void;
}

/**
 * Almikia Epic ER (TASK-004): one data-provider call per filter change
 * (NFR), through `CrmDataProvider.getFunnelMetrics` (TASK-002) -- mirrors
 * `useStageOpenLeadCounts.ts`'s own `useDataProvider` + react-query
 * convention. `filters` is part of the query key so a filter change (project,
 * lead type, or -- direccion only -- advisor) always refetches.
 */
export function useFunnelMetrics(
  filters: FunnelMetricsFilters,
): UseFunnelMetricsResult {
  const dataProvider = useDataProvider<CrmDataProvider>();

  const { data, isPending, error, refetch } = useQuery({
    queryKey: [
      "dashboard",
      "funnelMetrics",
      filters.advisorId ?? null,
      filters.projectId ?? null,
      filters.leadType ?? null,
    ],
    queryFn: () => dataProvider.getFunnelMetrics(filters),
    retry: false,
  });

  return { data, isPending, error, refetch: () => refetch() };
}
